import { API_URL } from '../../../config';

/** Derive the stage name from the API URL. */
function getStage(): 'dev' | 'production' {
  return API_URL.includes('.dev.') ? 'dev' : 'production';
}

/** Build a debug-opencode.sh command for the OpenCode debug UI on a sandbox instance. */
export function buildTunnelCommand(ec2InstanceId: string) {
  return `./scripts/debug-opencode.sh ${getStage()} ${ec2InstanceId}`;
}
